module.exports = __webpack_public_path__ + "static/media/noble-app-logo.e533da23.svg";